import React from "react";

import { trimestres } from "../../utils/copy";
import c1a from "../../assets/images/ConversasTerapeuticas/guests/c1-a.jpg";
import c2a from "../../assets/images/ConversasTerapeuticas/guests/c2-a.jpg";
import c3a from "../../assets/images/ConversasTerapeuticas/guests/c3-a.jpg";
import c4a from "../../assets/images/ConversasTerapeuticas/guests/c4-a.jpeg";

/* Polaroid da convidada em DOM (antes era JPG composto com a arte bakeada):
   moldura, rasgo e rotação viram CSS/markup de verdade.
   Uma convidada por ciclo (decisão da Manuela, jul/2026). */
export const cycleGuestPortraits: Record<
  number,
  { foto: string; real: boolean }
> = {
  1: { foto: c1a, real: true },
  2: { foto: c2a, real: true },
  3: { foto: c3a, real: true },
  4: { foto: c4a, real: true },
};

type CycleGuestsProps = { cycle: 1 | 2 | 3 | 4 };

export function CycleGuests({ cycle }: CycleGuestsProps) {
  const { foto, real } = cycleGuestPortraits[cycle];
  const trimestre = trimestres[cycle - 1];
  const nome = trimestre?.convidadas ?? "";
  /* ciclo sem foto real: não publicar o nome (contrato do teste / copy) */
  const nomeVisivel = real ? nome : "Nome pendente";

  return (
    <div className="cycle-guests">
      <p aria-hidden="true" className="cycle-guests-label">Convidada</p>

      <div className="cycle-guest-stack">
        <figure className="polaroid polaroid-a">
          {/* .polaroid-paper leva a máscara de rasgo; o drop-shadow fica na
              figure, DEPOIS da máscara do filho, então a sombra segue a
              silhueta rasgada (filter no mesmo elemento da mask não seguiria) */}
          <span className="polaroid-paper">
            {/* data-motion="media" aqui: o tratamento de foto global (fundo
                concreto, flash e grão) e o reveal do island valem pro miolo
                da polaroid, não pro painel inteiro */}
            <span data-motion="media" className="polaroid-photo">
              <img
                src={foto}
                alt={real ? `${nome}, convidada do ciclo` : ""}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </span>
          </span>
          <figcaption className="sr-only">
            {real
              ? `Convidada do ciclo: ${nome}.`
              : "Convidada do ciclo: fotografia e nome pendentes de confirmação."}
          </figcaption>
        </figure>
        <p className="cycle-guest-name">{nomeVisivel}</p>
      </div>
    </div>
  );
}
